<p bitTypography="body1" class="tw-mb-0 tw-text-xl">
  {{ "openExtensionManuallyPart1" | i18n }}
  <bit-icon
    [icon]="BitwardenIcon"
    class="[&>svg]:tw-align-baseline [&>svg]:-tw-mb-[2px]"
  ></bit-icon>
  {{ "openExtensionManuallyPart2" | i18n }}
</p>
